module.exports = __webpack_public_path__ + "static/media/Nexus 5x.3a666540.png";